import React from 'react';

interface DatePickerProps {
  value?: Date | string;
  showClearButton?: boolean;
  placeholder?: string;
  floatLabelType?: string;
  className?: string;
  change?: (args: { value: any }) => void;
}

export const DatePickerComponent = ({ value, placeholder, change, showClearButton = false, className }: DatePickerProps) => {
  const toInputDate = (d?: Date | string) => {
    if (!d) return '';
    const dt = typeof d === 'string' ? new Date(d) : d;
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      if (change) change({ value: null });
      return;
    }
    // parse YYYY-MM-DD as local date (avoid Date(string) which is treated as UTC)
    const parts = e.target.value.split('-');
    if (parts.length === 3) {
      const y = Number(parts[0]);
      const m = Number(parts[1]) - 1;
      const d = Number(parts[2]);
      const val = new Date(y, m, d);
      if (change) change({ value: val });
      return;
    }
    const fallback = e.target.value ? new Date(e.target.value) : null;
    if (change) change({ value: fallback });
  };

  const handleClear = () => {
    if (change) change({ value: null });
  };

  return (
    <div className={className || ''}>
      <input
        type="date"
        defaultValue={toInputDate(value)}
        placeholder={placeholder}
        onChange={handleChange}
        className="border dark:border-gray-600 p-1 rounded dark:bg-[#33373E] dark:text-gray-200 focus:outline-none"
      />
      {showClearButton && (
        <button type="button" onClick={handleClear} className="ml-2 px-2 py-1 border dark:border-gray-600 rounded dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
          Clear
        </button>
      )}
    </div>
  );
};

export default DatePickerComponent;
